export default {
	"query": {
		"queryToAccept": "accept",
		"isProject": "Is it a project",
		"customerName": "client's name",
		"packingWay": "Packing",
		"distributionTimes": "Delivery frequency",
		"startTime": "Expected start date",
		"neededUnloading": "distribution channel",
		"lastFile": "last attachment",
		"ageingRequirements": "Statute of limitations",
		"acceptTime": "reception time",
		"acceptName": "assignee",
		"handleTime": "application time",
		"handlePerson": "applicant",
		"note": "Remark",
		"feedBack": "Feedback",
		"submitUser": "Submitter",
		"transportationType": "type of transport",
		"submitTime": "submission time",
		"customerProfile": "Customer Profile",
		"temperatureRule": "temperature requirements",
		"applicationInformation": "Application Information"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/query/query.js